import * as React from 'react'
import Label from '../components/label'
import { css } from '@emotion/react'
import { StaticImage } from 'gatsby-plugin-image'

const About = () => {
  return (
    <section css={sectionStyle}>
      <div css={sectionInnerStyle}>
        <Label labelTitle={'POP-UP 3Dとは'} />
        <ul css={listStyle}>
          <li css={listImageStyle}>
            <StaticImage src="../assets/images/about01.png" alt="POP-UP 3Dとは" />
          </li>
          <li css={listImageStyle}>
            <StaticImage src="../assets/images/about02.png" alt="POP-UP 3Dとは" />
          </li>
          <li css={listImageStyle}>
            <StaticImage src="../assets/images/about03.png" alt="POP-UP 3Dとは" />
          </li>
        </ul>
        <div css={readStyle}>3DプリントとVR空間との融合</div>
        <div css={textStyle}>
          DMM.make
          3Dプリントが開催するバーチャルギャラリーでは現代彫刻やポップカルチャーなど様々なジャンルからテーマ毎に集まったクリエイターの3DモデルをVR空間上に展示します。
          <br />
          展示される3Dモデルは360度、好きな方向から隅々まで見ることが可能！企画しているイベントではクリエイターによる作品の解説やプレゼンを聞いたり、直接質問をしたり、作品を通して交流ができます。
          <br />
          また、展示される3Dモデルはクリエイターズマーケットで販売しています。気に入った3Dモデルを見つけたら是非クリエイターのショップを御覧ください。
        </div>
      </div>
    </section>
  )
}

const sectionStyle = css`
  width: 100%;
  margin-top: 120px;
  @media (max-width: 768px) {
    margin-top: 44px;
  }
`
const sectionInnerStyle = css`
  width: 1024px;
  margin: 0 auto;
  @media (max-width: 1023px) {
    width: 100%;
    padding: 0 24px;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 16px;
  }
`
const listStyle = css`
  display: flex;
  justify-content: space-between;
  margin: 0 62px;
  padding-top: 44px;
  @media (max-width: 768px) {
    margin: 0;
  }
`
const listImageStyle = css`
  width: 230px;
  @media (max-width: 768px) {
    width: auto;
    margin-right: 24px;
    &:last-child {
      margin-right: 0;
    }
  }
`
const readStyle = css`
  margin: 0 62px;
  padding-top: 40px;
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1;
  @media (max-width: 768px) {
    margin: 0;
  }
`
const textStyle = css`
  margin: 0 62px;
  padding-top: 16px;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.8;
  @media (max-width: 768px) {
    margin: 0;
  }
`

export default About
